import React from 'react';
import { useReveal } from '../lib/useReveal';
const FEATURES = ['Descargable', 'Editable', 'Digital', 'Entrega inmediata'];
export function CertificateSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#f5efe0] py-5 md:py-10 px-5 sm:px-6 border-t border-[#2d3f2a]/5" data-id="element-45">
      <div className="container mx-auto max-w-4xl" data-id="element-46">
        <div ref={ref} className={`reveal bg-gradient-to-br from-[#faf3e3] to-[#ede4d0] border border-[#b8860b]/30 rounded-3xl p-8 md:p-14 text-center shadow-md relative overflow-hidden ${vis ? 'is-visible' : ''}`} data-id="element-47">
          <div className="absolute -top-20 -right-20 w-40 h-40 bg-[#b8860b]/8 rounded-full blur-3xl" data-id="element-48"></div>
          <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-[#5a6b3f]/8 rounded-full blur-3xl" data-id="element-49"></div>

          <div className="relative z-10" data-id="element-50">
            <div className="inline-flex items-center justify-center mb-6" data-id="element-51">
              <div className="relative" data-id="element-52">
                <div className="w-20 h-20 rounded-full bg-[#b8860b]/10 border-2 border-[#b8860b]/30 flex items-center justify-center" data-id="element-53">
                  <span className="text-4xl" data-id="element-54">🎓</span>
                </div>
              </div>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#1e3a1e] mb-5" data-id="element-55">
              Certificado digital incluido
            </h2>

            <p className="text-[#3a4a35] text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-8" data-id="element-56">
              Recibí tu certificado digital editable junto con todo el contenido
              de la formación.
            </p>

            <div className="flex flex-wrap justify-center gap-3" data-id="element-57">
              {FEATURES.map((feature, i) => <div key={i} className="inline-flex items-center gap-2 bg-white/70 border border-[#2d3f2a]/15 rounded-full px-4 py-2 shadow-sm" data-id="element-58">
                  <span className="text-[#5a6b3f] font-bold" data-id="element-59">✓</span>
                  <span className="text-[#1e3a1e] text-sm font-semibold" data-id="element-60">
                    {feature}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}